import PatientRepository from '@/js/repositories/PatientRepository'
import moment from 'moment'
import i18n from '@/lang/i18n.js'
import { checkOldId } from '@/js/commons/commons'
moment.suppressDeprecationWarnings = true

const state = {
    errorMsg: '',
	info: null,
	seizures: null,
	pdf: null,
	videos: null,
	videoInOnePage: null,
	viewedHistories: [],
	seizureChangeRate: [],
	drSelectPatient: null,
	dr_children_note: null,
	basic_info: null,
	dr_patient_name: null,
	sleep: {}
}
const getters = {
	shortcats: (state) => {
		if (state.seizures.seizures_shortcat) {
		  return state.seizures.seizures_shortcat.filter((shortcat) => shortcat)
		}
		return null
	}
}
function getSeizureData(seizureShortcats, seizuresData, listDates, fromYesterday, to, type) {
	var shortcatIds = seizureShortcats.map(function (shortcat) {
		if (shortcat !== null) {
			return shortcat.id
		}
	});
	seizuresData.forEach(seizure => {
		if (seizure) {
			if (seizure.seizure_shortcat_id !== null && !shortcatIds.includes(seizure.seizure_shortcat_id)) {
				seizure.seizure_shortcat_id = null;
			}
		}
	});
	var seizuresGroupByShortcat = groupBy(seizuresData, 'seizure_shortcat_id');
	var data = [];
	for (var shortcatId in seizuresGroupByShortcat) {
		if (seizuresGroupByShortcat.hasOwnProperty(shortcatId)) {
			var shortcatIndex = getShortcatIndexById(seizureShortcats, shortcatId);
			var seizuresByDate = type === 'day' ? getSeizureByDate(seizuresGroupByShortcat[shortcatId], listDates) : getSeizureBetweenTwoDate(seizuresGroupByShortcat[shortcatId], listDates, fromYesterday, to);
			data.push({'shortcat_index': shortcatIndex, 'data': seizuresByDate});
		}
	}
	return data;
}

function groupBy(array, key) {
    return array.reduce(function (acc, obj) {
        var property = obj[key];
        acc[property] = acc[property] || [];
        acc[property].push(obj);
        return acc;
    }, []);
}

function getListDateBetweenTwoDate(from, to) {
	var fromDate = new Date(from);
	var toDate = new Date(to);
	var dates = [];
	var currentDate = fromDate;
	
	while (currentDate <= toDate) {
		dates.push(currentDate.toISOString().slice(0, 10));
		currentDate.setDate(currentDate.getDate() + 1);
	}
	return dates;
}

function getShortcatIndexById(seizureShortcats, id) {
	if (id === '') return null;
	else {
		for (var i = 0; i < seizureShortcats.length; i++) {
			if (seizureShortcats[i] && seizureShortcats[i].id === id) return seizureShortcats[i].shortcat_index;
		}
	}
}

function getSeizureByDate(seizures, date) {
	var seizureCountArr = new Array(24).fill(0);
	seizures.forEach(seizure => {
		var event_start_hour = new Date(seizure.event_start_time).getHours();
		if (seizure.event_date === date) {
			seizureCountArr[event_start_hour] += 1;
		}
	});
	return seizureCountArr;
}

function getSeizureBetweenTwoDate(seizures, date, fromYesterday, to) {
	var seizureCountArr = new Array(date.length).fill(0);
	seizures.forEach(seizure => {
		var event_start_hour = new Date(seizure.event_start_time).getHours();
		var event_date = new Date(seizure.event_date).toISOString().slice(0, 10);
		if (event_date === fromYesterday) {
			if (event_start_hour > new Date(seizure.event_end_time).getHours()) {
				var index = date.indexOf(event_date);
				seizureCountArr[index] += 1;
			}
		} else {
			var index = date.indexOf(event_date);
			seizureCountArr[index] += 1;
		}
	});
	return seizureCountArr;
}

function getListBetweenTwoDate(seizures, listDates, fromYesterday, to) {
	var arrVideo = new Array(listDates.length).fill(0);
	var arrMedicine = new Array(listDates.length).fill(0);
	
	seizures.forEach(seizure => {
		var index = listDates.indexOf(seizure.event_date);
		if (seizure.seizure_video.length > 0 && seizure.seizure_video.some(video => video.video_url !== null) && arrVideo[index] === 0) {
			var event_start_hour = new Date(seizure.event_start_time).getHours();
			var event_end_hour = new Date(seizure.event_end_time).getHours();
			if (seizure.event_date === fromYesterday) {
				if (event_start_hour > event_end_hour) {
					arrVideo[index] = 1;
				}
			} else {
				if (event_start_hour > event_end_hour) {
					if (seizure.event_date !== to) {
						index = listDates.indexOf(seizure.event_date);
						arrVideo[index + 1] = 1;
					}
				}
				arrVideo[index] = 1;
			}
		}
		if (seizure.dosage && arrMedicine[index] === 0) {
			var event_start_hour = new Date(seizure.event_start_time).getHours();
			var event_end_hour = new Date(seizure.event_end_time).getHours();
			if (seizure.event_date === fromYesterday) {
				if (event_start_hour > event_end_hour) {
					arrMedicine[index] = 1;
				}
			} else {
				if (event_start_hour > event_end_hour) {
					if (seizure.event_date !== to) {
						index = listDates.indexOf(seizure.event_date);
						arrMedicine[index + 1] = 1;
					}
				}
				arrMedicine[index] = 1;
			}
		}
	});
	return {'videos': arrVideo, 'medicines': arrMedicine};
}
const actions = {
	setErrorMsg({ commit }, data) {
		commit('PATIENT_ERROR', data)
	},
	setPatientInfo({ commit }, data) {
		commit('PATIENT_INFO', data)
	},
	async getInfo({ commit }, data) {
		await PatientRepository.getInfo(data)
			.then(res => {
				let data = checkOldId(res.data.data, true)
                commit('PATIENT_ERROR', '')
                commit('PATIENT_INFO', data)
			})
			.catch(error => {
				let errMes = i18n.t('api_has_occurred_with_status', {status: error.response.status})
				if (error.response.status === 403) {
					i18n.t('the_otp_has_expired_or_the_use_of_the_otp_has_been_suspended')
					errMes = i18n.t('the_otp_has_expired_or_the_use_of_the_otp_has_been_suspended', {status: error.response.status})
				}
				commit('PATIENT_INFO', '')
                commit('PATIENT_ERROR', errMes)
			})
	},
	async getSeizures({ commit }, payload) {
		let type = payload.params.one_time_access_key ? 'one_time_access_key' : 'childId'
		// get list date from payload
		let to_date = moment(payload.params.to_date)
		let from_date = moment(payload.params.from_date)
		let list_dates = []

		//will we get data for many days?
		let is_get_many_days = to_date.diff(from_date) != 0 ? true : false
		let is_use_session_many_days = false
		let is_use_session_one_date = false
		let session_list_date = []
		let session_graph_data = {}
		let session_graph_data_one_date = JSON.parse(sessionStorage.getItem('seizure_graph_data_one_date_'+ payload.params[type])) || {}
		let session_graph_data_one_day_default = {
			time_created: Date.now(),
			data: {}
		}


		//delete session after 10 minutes (600000 miliseconds)
		let session_seizure_graph_time_created = JSON.parse(sessionStorage.getItem('seizure_graph_time_created_'+ payload.params[type])) || 0
		if ( session_seizure_graph_time_created == 0 ) {
			sessionStorage.setItem('seizure_graph_time_created_'+ payload.params[type], JSON.stringify(Date.now()))
		}
		else if ( Date.now() - session_seizure_graph_time_created  > 600000 ) {
			sessionStorage.removeItem('seizure_graph_data_'+ payload.params[type])
			sessionStorage.removeItem('seizure_graph_list_date_'+ payload.params[type])
			sessionStorage.removeItem('seizure_graph_time_created_'+ payload.params[type])
		}
		if ( typeof(session_graph_data_one_date.time_created) === 'undefined' ) {
			session_graph_data_one_date = session_graph_data_one_day_default
			sessionStorage.setItem('seizure_graph_data_one_date_'+ payload.params[type], JSON.stringify(session_graph_data_one_date))
		}
		else if ( Date.now() - session_graph_data_one_date.time_created  > 600000 ) {
			sessionStorage.removeItem('seizure_graph_data_one_date_'+ payload.params[type])
		}

		if (is_get_many_days){	
			// get list date from session
			session_list_date = JSON.parse(sessionStorage.getItem('seizure_graph_list_date_'+ payload.params[type])) || []
			// get session_graph_data from session
			session_graph_data = JSON.parse(sessionStorage.getItem('seizure_graph_data_'+ payload.params[type])) || {}
			// check can we use session data instead of api
			is_use_session_many_days = Object.keys(session_graph_data).length > 0 && is_get_many_days ? true : false
			//get list date will get data from params
			while(to_date.diff(from_date) >= 0){
				list_dates.push(from_date.format('YYYY/MM/DD'))
				//check the date is exists in session or not
				if ( session_list_date.includes(from_date.format('YYYY/MM/DD')) == false ){
					//set params use session to false if date not exists
					if ( is_use_session_many_days ){
						is_use_session_many_days = false;
					}
					//add date to session
					session_list_date.push(from_date.format('YYYY/MM/DD'))
				}
				//add 1 day to params
				from_date.add(1, 'days')
			}
			//save new list date to session
			sessionStorage.setItem('seizure_graph_list_date_'+ payload.params[type], JSON.stringify(session_list_date))
		}
		else{
			is_use_session_one_date = Object.keys(session_graph_data_one_date.data).includes(from_date.format('YYYY/MM/DD')) && Object.keys(session_graph_data_one_date.data).length > 0 && (is_get_many_days == false) ? true : false
		}

		if( is_use_session_many_days ) {
			//initialization default data will return
			let video_list = []
			let seizure_medication = []
			let seizures_shortcat = []
			let seizure_data = [
				{data: [], shortcat_index: 0},
				{data: [], shortcat_index: 1},
				{data: [], shortcat_index: 2},
				{data: [], shortcat_index: 3},
				{data: [], shortcat_index: 4},
				{data: [], shortcat_index: 5},
				{data: [], shortcat_index: null},
			]


			//get data for video_list, seizure_medication and seizure data
			list_dates.forEach( date => {
				video_list.push(session_graph_data.video_list[date] || 0)
				seizure_medication.push(session_graph_data.seizure_medication[date] || 0)
				seizure_data[0].data.push(session_graph_data.seizure_data[0].data[date] || 0)
				seizure_data[1].data.push(session_graph_data.seizure_data[1].data[date] || 0)
				seizure_data[2].data.push(session_graph_data.seizure_data[2].data[date] || 0)
				seizure_data[3].data.push(session_graph_data.seizure_data[3].data[date] || 0)
				seizure_data[4].data.push(session_graph_data.seizure_data[4].data[date] || 0)
				seizure_data[5].data.push(session_graph_data.seizure_data[5].data[date] || 0)
				seizure_data[6].data.push(session_graph_data.seizure_data[6].data[date] || 0)
			})
			//get data for seizures_shortcat
			let min_date = session_graph_data.min_date
			seizures_shortcat = session_graph_data.seizures_shortcat
			//set data will return
			let seizure_graph_data = {
				seizures_shortcat: seizures_shortcat,
				seizure_data: seizure_data,
				video_list: video_list,
				seizure_medication: seizure_medication,
				min_date: min_date
			}
			commit('PATIENT_ERROR', '')
			commit('SET_SEIZURES', seizure_graph_data)
		}
		else if (is_use_session_one_date) {
			commit('PATIENT_ERROR', '')
			commit('SET_SEIZURES', session_graph_data_one_date.data[from_date.format('YYYY/MM/DD')])
		}
		else {
			// await PatientRepository.getSeizuresByChildId(payload)
			await PatientRepository.getSeizures(payload, type)
				.then(res => {
					var dataSeizure = []
					var from = moment(payload.params.from_date, 'YYYY-MM-DD').format('YYYY-MM-DD')
					var to = moment(payload.params.to_date, 'YYYY-MM-DD').format('YYYY-MM-DD')
					var seizuresData = res.data.data.get_seizure
					var getSeizureVideo = res.data.data.get_seizure_video
					var seizureShortcats = res.data.data.seizures_shortcat
					if (seizuresData) {
						seizuresData.map(function(item) {
							item.seizure_video = getSeizureVideo.filter(function(video) {
								return video.seizure_id === item.id;
							});
						});
						var listDates = getListDateBetweenTwoDate(from, to);
						var data = getSeizureData(seizureShortcats, seizuresData, listDates, fromYesterday, to, 'month');
    					var listData = getListBetweenTwoDate(seizuresData, listDates, fromYesterday, to);	
						var fromYesterday = moment(from, 'YYYY-MM-DD').subtract(1, 'days').format('YYYY-MM-DD');							
						dataSeizure = {
							seizures_shortcat: seizureShortcats,
							seizure_data: data,
							video_list: listData.videos,
							seizure_medication: listData.medicines,
							min_date: res.data.data.min_date
						}
					} else {
						dataSeizure = res.data.data
					}
					commit('PATIENT_ERROR', '')
					commit('SET_SEIZURES', dataSeizure)
					//save data to session if we get data for many days
					if (is_get_many_days) {
					//initialization will save to session
						let session_data_default = {
							seizures_shortcat: [],
							seizure_data: [
								{data: {}, shortcat_index: 0},
								{data: {}, shortcat_index: 1},
								{data: {}, shortcat_index: 2},
								{data: {}, shortcat_index: 3},
								{data: {}, shortcat_index: 4},
								{data: {}, shortcat_index: 5},
								{data: {}, shortcat_index: null},
							],
							video_list: {},
							seizure_medication: {},
							min_date: res.data.data.min_date
						}
						//get data from session if session exist or use default data
						let session_seizure_graph_data = JSON.parse(sessionStorage.getItem('seizure_graph_data_'+ payload.params[type])) || session_data_default
						let data_from_api = dataSeizure
						//push data to session_seizure_graph_data.seizure_data
						data_from_api.seizure_data.forEach( element => {
							element.data.forEach( (data, index) => {
								if(data) {
									if (element.shortcat_index === undefined) {
										element.shortcat_index = null
									}
									session_seizure_graph_data.seizure_data[(element.shortcat_index != null ? element.shortcat_index : 6)].data[list_dates[index]] = data
								}
							})
						})
						//push data to session_seizure_graph_data.video_list and seizure_medication
						list_dates.forEach( (date, index) => {
							session_seizure_graph_data.video_list[date] = data_from_api.video_list[index] || 0
							session_seizure_graph_data.seizure_medication[date] = data_from_api.seizure_medication[index] || 0
						})
						//push data to session_seizure_graph_data.seizures_shortcat
						session_seizure_graph_data.seizures_shortcat = data_from_api.seizures_shortcat
						// save data to the session
						sessionStorage.setItem('seizure_graph_data_'+ payload.params[type], JSON.stringify(session_seizure_graph_data))
					}
					else{
						session_graph_data_one_date.data[from_date.format('YYYY/MM/DD')] = res.data.data
						sessionStorage.setItem('seizure_graph_data_one_date_'+ payload.params[type], JSON.stringify(session_graph_data_one_date))
					}
				})
				.catch(error => {
					let errMes = i18n.t('api_has_occurred_with_status', {status: error.response.status})
					if (error.response.status === 403) {
						errMes = i18n.t('the_otp_has_expired_or_the_use_of_the_otp_has_been_suspended', {status: error.response.status})
					}
					commit('PATIENT_INFO', '')
					commit('PATIENT_ERROR', errMes)
				})
		}
	},
	setPDF({ commit }, data) {
		commit('PDF', data)
	},
	async getVideos({ commit }, payload) {
		await PatientRepository.getVideos(payload)
			.then(res => {
				commit('PATIENT_ERROR', '')
				if(payload.params.page) commit('SET_VIDEO_IN_ONE_PAGE', res.data.data.videos)
				else commit('SET_VIDEOS_CHART', res.data.data.videos)
			})
			.catch(error => {
				if(payload.params.page) commit('SET_VIDEO_IN_ONE_PAGE', '')
				else commit('SET_VIDEOS_CHART', '')
                commit('PATIENT_ERROR', 'ERROR GET INFO')
			})
	},
	resetPatientInfo({ commit }) {
		commit('RESET_PATIENT_INFO')
	},
	async getViewedHistories({ commit }) {
		await PatientRepository.getViewedHistories()
			.then(res => {
                commit('SET_VIEWED_HISTORIES', res.data.data)
			})
			.catch(error => {
				commit('SET_VIEWED_HISTORIES', [])
			})
	},
	async getInfoByChildId({ commit }, childId) {
		await PatientRepository.getInfoByChildId(childId)
			.then(res => {
				let data = checkOldId(res.data.data, true)
                commit('PATIENT_ERROR', '')
                commit('PATIENT_INFO', data)
			})
			.catch(error => {
				let errMes = i18n.t('api_has_occurred_with_status', {status: error.response.status})
				if (error.response.status === 403) {
					errMes = i18n.t('the_otp_has_expired_or_the_use_of_the_otp_has_been_suspended', {status: error.response.status})
				}
				commit('PATIENT_INFO', '')
                commit('PATIENT_ERROR', errMes)
			})
	},
	async getVideosByChildId({ commit }, payload) {
		await PatientRepository.getVideosByChildId(payload)
			.then(res => {
				commit('PATIENT_ERROR', '')
                if(payload.params.page) commit('SET_VIDEO_IN_ONE_PAGE', res.data.data.videos)
				else commit('SET_VIDEOS_CHART', res.data.data.videos)
			})
			.catch(error => {
				if(payload.params.page) commit('SET_VIDEO_IN_ONE_PAGE', '')
				else commit('SET_VIDEOS_CHART', '')
                commit('PATIENT_ERROR', 'ERROR GET INFO')
			})
	},
	async getDataSeizureChangeRate({ commit }, payload) {
		await PatientRepository.getDataSeizureChangeRate(payload)
			.then(res => {
				commit('PATIENT_ERROR', '')
                commit('SET_SEIZURE_CHANGE_RATE', res.data.data)
			})
			.catch(error => {
				commit('SET_SEIZURE_CHANGE_RATE', '')
                commit('PATIENT_ERROR', 'ERROR GET SET_SEIZURE_CHANGE_RATE')
			})
	},
	async drSelectPatient({ commit }, data) {
		await PatientRepository.drSelectPatient(data)
			.then(res => {
				commit('SET_DR_SELECT_PATIENT', res.data.data)
			})
			.catch(error => {
				console.log(error.response)
			})
	},
	async getSleepData({ commit }, payload) {
		
		await PatientRepository.getSleepData(payload)
			.then(res => {
                commit('SET_SLEEP', res.data.data)
			})
			.catch(error => {
				commit('SET_SLEEP', '')
			})
	},
	async registerDrChildrenNote({ commit }, data) {
		await PatientRepository.registerDrChildrenNote(data)
			.then(res => {
				commit('DR_CHILDREN_NOTE', res.data.data)
			})
			.catch(error => {
				commit('DR_CHILDREN_NOTE', error.response.status)
			})
	},
	async getBasicInfoByChildId({ commit }, childId) {
		await PatientRepository.getBasicInfoByChildId(childId)
			.then(res => {
                let data = checkOldId(res.data.data, true)
                commit('BASIC_INFO', data)
			})
			.catch(error => {
				let errMes = i18n.t('api_has_occurred_with_status', {status: error.response.status})
				if (error.response.status === 403) {
					i18n.t('the_otp_has_expired_or_the_use_of_the_otp_has_been_suspended')
					errMes = i18n.t('the_otp_has_expired_or_the_use_of_the_otp_has_been_suspended', {status: error.response.status})
				}
				commit('BASIC_INFO', '')
			})
	},
	async drPatientName({ commit }, data) {
		await PatientRepository.drPatientName(data)
			.then(res => {
				commit('DR_PATIENT_NAME', res.data.data)
			})
			.catch(error => {
				commit('DR_PATIENT_NAME', error.response.status)
			})
	}
}
const mutations = {
	INIT(state) {
        state.info     = null
        state.errorMsg = ''
	},
	PATIENT_ERROR(state, errMsg) {
		state.errorMsg = errMsg
    },
    PATIENT_INFO(state, data) {
        state.info = data
	},
	SET_SEIZURES(state, data) {
        state.seizures = data
	},
	PDF(state, data) {
        state.pdf = data
	},
	SET_VIDEOS_CHART(state, data) {
        state.videos = data
	},
	SET_VIDEO_IN_ONE_PAGE(state, data) {
        state.videoInOnePage = data
	},
	RESET_PATIENT_INFO(state) {
        state.info = state.seizures  = null
	},
	SET_VIEWED_HISTORIES(state, data) {
        state.viewedHistories = data
	},
	SET_SEIZURE_CHANGE_RATE(state, data) {
		state.seizureChangeRate = data
	},
	SET_DR_SELECT_PATIENT(state, data) {
        state.drSelectPatient = data
	},
	SET_SLEEP(state, data) {
		state.sleep = data
	},
	DR_CHILDREN_NOTE(state, data) {
		state.dr_children_note = data
	},
	BASIC_INFO(state, data) {
		state.basic_info = data
	},
	DR_PATIENT_NAME(state, data) {
		state.dr_patient_name = data
	}
}
export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}
